import { BASE_BORDER_RADIUS } from 'styles/Base';
import {
  CLOUD,
  GRAY,
  IRON,
  MIST,
  NAVY,
  SHADOWS,
  SKY,
  TERTIARY_TEXT,
  WHITE_BACKGROUND,
  WHITE_TEXT
} from 'styles/Colors';
import { isFunction } from 'lodash';
import { LargeMobile } from 'styles/MediaQueries';
import { SET_DATA, SET_ERROR } from 'helpers/Constants';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from 'components/forms/Checkbox';
import CtaButton from '@opploans/cta-button-component/CtaButton';
import Print from 'images/Print.svg';
import React, { useState } from 'react';

const containerStyle = {
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: NAVY,
  borderRadius: BASE_BORDER_RADIUS,
  margin: '1rem'
};

const headerStyle = {
  padding: '1rem',
  boxShadow: `0 4px 8px ${SHADOWS}`,
  display: 'flex',
  justifyContent: 'space-between',
  p: {
    paddingLeft: '1.25rem',
    fontFamily: 'Arimo',
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: '24px',
    color: SKY
  },
  fontFamily: 'Arimo',
  fontSize: '14px'
};

const visibleCheckboxStyle = {
  maxHeight: '25rem',
  padding: '0.5rem',
  opacity: 1,
  transition: 'all 1s ease-in-out'
};

const buttonStyle = {
  backgroundColor: CLOUD,
  color: SKY,
  border: `1px solid ${GRAY}`,
  fontSize: '16px',
  width: '100%',
  marginTop: '0.5rem',
  '&:active, &:hover': {
    backgroundColor: `${GRAY}!important`
  }
};

const printButtonStyle = {
  fontWeight: 'bold',
  fontSize: '1.25rem',
  display: 'inline-flex',
  lineHeight: '1.25rem',
  cursor: 'pointer',
  background: 'none',
  border: 'none'
};

const printIconStyle = {
  height: '3.25rem'
};

function ScrollToCheckbox({
  bodyContent,
  checkboxLabel,
  id,
  name,
  scrollableAreaHeight,
  dataAttrs,
  onClose,
  onPrint
}) {
  const [enableCheckbox, setEnableCheckbox] = useState(false);
  const elecCommDisclosure = useSelector((state) => state.elecCommDisclosure);
  const [showScrollMessage, setShowScrollMessage] = useState(false);

  const dispatch = useDispatch();

  const handleScroll = (e) => {
    const el = e.target;
    const buffer = 10;
    // buffer fixes an issue with various screensizes and scroll methods
    // scrollHeight is the total height of all the text
    // scrollTop is how far the user has scrolled so far
    // clientHeight is the visible area
    if (el.scrollHeight - Math.ceil(el.scrollTop) - buffer <= el.clientHeight) {
      setEnableCheckbox(true);
      setShowScrollMessage(false);
      if (!elecCommDisclosure) {
        dispatch({ type: SET_ERROR, payload: { elecCommDisclosure: true } });
      }
    }
  };
  const handleChange = (e) => {
    dispatch({
      type: SET_DATA,
      payload: { elecCommDisclosure: e.target.checked }
    });
    dispatch({
      type: SET_ERROR,
      payload: { elecCommDisclosure: !e.target.checked }
    });
  };

  const handleClick = () => {
    if (!enableCheckbox) {
      setShowScrollMessage(true);
    }
  };

  const handleGoBack = () => {
    dispatch({
      type: SET_DATA,
      payload: { elecCommDisclosure: false }
    });
    onClose();
  };
  const scrollableAreaStyle = {
    overflowY: 'scroll',
    padding: '1.25rem',
    fontSize: '12px',
    color: TERTIARY_TEXT,
    maxHeight: scrollableAreaHeight,
    [LargeMobile]: {
      maxHeight: window.innerHeight - 380,
      padding: '2rem'
    }
  };
  return (
    <div css={[containerStyle]}>
      <div css={headerStyle}>
        <div>
          <p>The Electronic Communications Agreement</p>
        </div>
        <button
          data-print-target='electronic-disclosure-body'
          id='ec-print-btn'
          css={printButtonStyle}
          type='button'
          onClick={() => {
            if (isFunction(onPrint)) {
              onPrint();
            }
          }}
        >
          <Print title='print' css={printIconStyle} />
        </button>
      </div>
      <div
        css={[scrollableAreaStyle]}
        onScroll={handleScroll}
        data-testid='scrollableArea'
      >
        {bodyContent}
        {showScrollMessage && (
          <div
            css={{
              display: 'flex',
              width: '100%',
              position: 'sticky',
              bottom: '-1rem'
            }}
          >
            <span
              css={{
                backgroundColor: SKY,
                display: 'inline-block',
                margin: '0 auto',
                padding: '10px',
                borderRadius: '5px',
                fontSize: '1rem',
                color: WHITE_TEXT
              }}
            >
              Scroll to the bottom to consent
            </span>
          </div>
        )}
      </div>
      {/* eslint-disable-next-line jsx-a11y/interactive-supports-focus */}
      <div
        role='button'
        onKeyDown={handleClick}
        onClick={handleClick}
        css={[visibleCheckboxStyle]}
      >
        <Checkbox
          id={id}
          label={checkboxLabel}
          name={name}
          onChange={handleChange}
          value={elecCommDisclosure}
          dataAttrs={dataAttrs}
          disabled={!(enableCheckbox || elecCommDisclosure)}
          additionalCheckboxStyle={{
            borderRadius: 0,
            backgroundColor: WHITE_BACKGROUND
          }}
          additionalLabelStyle={{
            fontSize: '11px',
            display: 'flex',
            placeItems: 'center stretch',
            backgroundColor: MIST,
            padding: '0.5rem'
          }}
        />
      </div>
      <div css={{ padding: '.5rem', marginTop: '-0.5rem' }}>
        <CtaButton
          additionalStyle={{
            width: '100%',
            '&:disabled, &:disabled:hover': {
              background: GRAY,
              color: IRON
            },
            fontSize: '16px',
            padding: '13px'
          }}
          disabled={!(elecCommDisclosure || elecCommDisclosure)}
          id='elecCommModalContinue'
          onClick={onClose}
        >
          Continue
        </CtaButton>
        <CtaButton additionalStyle={buttonStyle} onClick={handleGoBack}>
          Go Back
        </CtaButton>
      </div>
    </div>
  );
}

export default ScrollToCheckbox;
